import PageHeader from '@/components/layout/PageHeader';
import React, { useState } from 'react';
import useSearchList from '@/hooks/useSearchList';
import ExportJsonExcel from 'js-export-excel'; //excel表格导出
import { getListPayload } from '@/scripts/utils';
import { SEARCH_ITEM_COL, SEARCH_ITEM_GUTTER } from '@/scripts/config';
import { Button, Card, Col, Space, Dropdown, DatePicker, Checkbox, Form, message, Row, Select } from 'antd';
import { useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';
import { createJsonOptions, getLabelFromMap } from '@/scripts/utils';
import ajax from '@/scripts/ajax';
import dayjs from 'dayjs';
import locale from 'antd/es/date-picker/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import { data } from 'browserslist';

const pageKey = 'HplOrderList';
export default function HplOrderList() {
    // hooks
    const [form] = Form.useForm();
    const { data: startPortOptions } = useGetStartPortQuery(1);
    const { data: endPortOptions } = useGetEndPortQuery(1);

    const [dataSource, setState] = useState([]);
    const [dataSourceAll, setStateAll] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState([]);
    const [checkboxState, setCheckboxState] = useState({});
    // const dateFormat = 'YYYY-MM-DD';

    const orderStatusOptions = [
        { label: '未提交订单', value: 0 },
        { label: '已提交', value: 1 },
        { label: '超时', value: 2 },
        { label: '正在锁定', value: 3 },
        { label: '退关', value: 4 },
    ];
    const quotationNumberOptions = [
        { label: 'qqs', value: 1 },
        { label: 'qq ', value: 0 },
    ];
    const USA_DESTINATIONS = [
        'LONG BEACH',
        'NEWARK',
        'HOUSTON',
        'OAKLAND',
        'BALTIMORE',
        'CHICAGO',
        'LOS ANGELES',
        'SAVANNAH',
        'NORFOLK',
        'MIAMI',
        'MOBILE',
        'NEW ORLEANS',
        'NEW YORK',
        'SEATTLE',
        'TACOMA',
        'CINCINNATI',
        'MEMPHIS',
        'FORT WORTH',
        'DALLAS',
        'CHARLESTON',
    ];

    // 判断目的港是否属于上述目的港
    const isUsaDestination = (destination) => {
        if (!destination) return false;
        const dest = String(destination).trim().toUpperCase();
        return USA_DESTINATIONS.some((city) => dest === city || dest.includes(city));
    };
    let tableTitle = [
        'ID',
        '账号',
        '起始港',
        '目的港',
        '箱型',
        '提单号',
        '免用箱',
        '价格',
        '目的港费用',
        '数量',
        '重量',
        'status_code',
        '开航时间',
        '下单时间',
        '截止提交时间',
        '提交时间',
        '状态',
    ];
    let tableFilter = [
        'id',
        'username',
        'origin_location',
        'destination_location',
        'box_type',
        'booking_number',
        'free_day',
        'price',
        'hpl_import_surcharges_amount',
        'quantity',
        'weight',
        'status_code',
        'earlytime',
        'book_time',
        'endtime',
        'updatetime',
        'is_book',
    ];

    const ExcelItems = [
        {
            key: '1',
            label: '导入当前页',
        },
        {
            key: '2',
            label: '导入全部页',
        },
    ];

    const [submittingId, setSubmittingId] = useState(null);
    const [disableIds, setDisableIds] = useState([]);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            width: 60,
            align: 'center',
        },
        {
            title: '账号',
            dataIndex: 'username',
            width: 100,
            align: 'left',
            sorter: (a, b) => a['username'].localeCompare(b['username']),
        },
        {
            title: '起始港',
            dataIndex: 'origin_location',
            width: 100,
            align: 'center',
            sorter: (a, b) => a['origin_location'].localeCompare(b['origin_location']),
        },
        {
            title: '目的港',
            dataIndex: 'destination_location',
            width: 100,
            align: 'center',
            sorter: (a, b) => a['destination_location'].localeCompare(b['destination_location']),
        },
        {
            title: '箱型',
            dataIndex: 'box_type',
            width: 140,
            align: 'center',
            sorter: (a, b) => a['box_type'].localeCompare(b['box_type']),
        },
        {
            title: '提单号',
            dataIndex: 'booking_number',
            width: 100,
            align: 'center',
            sorter: (a, b) => a?.booking_number - b?.booking_number,
        },
        {
            title: '免用箱',
            dataIndex: 'free_day',
            width: 80,
            align: 'center',
        },
        {
            title: '价格',
            dataIndex: 'price',
            width: 100,
            sorter: (a, b) => a?.price - b?.price,
        },
        {
            title: '目的港费用',
            dataIndex: 'hpl_import_surcharges_amount',
            width: 100,
        },
        {
            title: '数量',
            dataIndex: 'quantity',
            width: 100,
            sorter: (a, b) => a?.quantity - b?.quantity,
        },
        {
            title: '重量',
            dataIndex: 'weight',
            width: 100,
        },
        {
            title: 'status_code',
            dataIndex: 'status_code',
            width: 100,
        },
        {
            title: '开航时间',
            dataIndex: 'earlytime',
            width: 180,
            align: 'right',
            sorter: (a, b) => +new Date(a.earlytime) - +new Date(b.earlytime),
        },
        {
            title: '下单时间',
            dataIndex: 'book_time',
            width: 180,
            align: 'right',
            sorter: (a, b) => +new Date(a.book_time) - +new Date(b.book_time),
        },
        {
            title: '截止提交时间',
            dataIndex: 'endtime',
            width: 180,
            align: 'right',
            sorter: (a, b) => +new Date(a.endtime) - +new Date(b.endtime),
        },
        {
            title: '提交时间',
            dataIndex: 'updatetime',
            width: 180,
            align: 'right',
            sorter: (a, b) => +new Date(a.updatetime) - +new Date(b.updatetime),
        },
        {
            title: '状态',
            dataIndex: 'is_book',
            width: 100,
            align: 'center',
            render: (value) => getLabelFromMap({ map: orderStatusOptions, value }),
        },
        {
            title: '操作',
            key: 'actions',
            width: 100,
            align: 'center',
            render: (data) => {
                // 0: 未提交
                if (data.is_book === 0) {
                    const disabled = disableIds.includes(data.id);
                    return (
                        <Button loading={data.id === submittingId} onClick={() => handleOrderSubmit(data.id)} disabled={disabled}>
                            {disabled ? '下单完成' : '下单'}
                        </Button>
                    );
                }
                if (data.is_book === 1) {
                    const disabled = disableIds.includes(data.id);
                    return (
                        <Button loading={data.id === submittingId} onClick={() => handleShutOut(data.id)} disabled={disabled}>
                            {disabled ? '退关完成' : '退关'}
                        </Button>
                    );
                }

                return null;
            },
        },
        {
            title: 'is_usa',
            dataIndex: 'is_usa',
            width: 80,
            align: 'center',
            render: (_, record) => (
                <Checkbox
                    checked={!!checkboxState[record.id]?.is_usa}
                    onChange={(e) => handleCheckboxChange(record.id, 'is_usa', e.target.checked)}
                />
            ),
        },
        {
            title: 'is_specific',
            dataIndex: 'is_specific',
            width: 100,
            align: 'center',
            render: (_, record) => (
                <Checkbox
                    checked={!!checkboxState[record.id]?.is_specific}
                    onChange={(e) => handleCheckboxChange(record.id, 'is_specific', e.target.checked)}
                />
            ),
        },
    ];
    // 勾选变化
    const handleCheckboxChange = (id, field, checked) => {
        setCheckboxState((prev) => ({
            ...prev,
            [id]: { ...prev[id], [field]: checked },
        }));
    };

    // 根据目的港自动勾选 is_usa / is_specific
    const autoCheckByDestination = (list) => {
        if (!Array.isArray(list)) return;
        const autoState = {};
        list.forEach((item) => {
            if (isUsaDestination(item.destination_location)) {
                autoState[item.id] = { is_usa: true, is_specific: true };
            }
        });

        setCheckboxState((prev) => {
            const merged = { ...prev };
            Object.keys(autoState).forEach((id) => {
                // 仅在该行还没有任何勾选记录时自动勾选，避免覆盖用户手动修改
                if (!prev[id]) {
                    merged[id] = autoState[id];
                }
            });
            return merged;
        });
    };

    // 提交renderTable订单
    const handleOrderSubmit = async (id) => {
        setSubmittingId(id);
        const checked = checkboxState[id] || {};
        const payload = { id };
        // 勾选才传 true，不勾选不传
        if (checked.is_usa) payload.is_usa = true;
        if (checked.is_specific) payload.is_specific = true;

        const { bool_status, data } = await ajax.post('/hpl/book/order', payload, { rawResponse: true }).catch((err) => {
            console.log(err);
        });
        setSubmittingId(null);
        message.info(data);
        if (bool_status) setDisableIds([...disableIds, id]);
    };

    // 退关
    const handleShutOut = async (id) => {
        setSubmittingId(id);
        // const { bool_status, data } =
        await ajax
            .post('/hpl/book/out', { id })
            .then((res) => {
                message.info('成功退关');
                setDisableIds([...disableIds, id]);
            })
            .catch((err) => {
                console.log(err);
            });
        setSubmittingId(null);
    };

    // 表格钩子
    const { renderTable, renderSearchButton } = useSearchList({
        pageKey,
        tableConfig: { columns, rowKey: 'id', dataKey: 'data', totalKey: 'total_page', pageSize: 100 },
        form,
        fetchDataFormat: (data, total_page) => {
            let params = getListPayload({ form });
            params.per_page = 10000;
            // 获取导入全部数据
            ajax.post('/hpl/book/check', params)
                .then((res) => {
                    res.data.map((item) => {
                        item.earlytime = dayjs(item.earlytime).format('YYYY-MM-DD');
                        return item;
                    });

                    setStateAll(res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
            if (data) {
                data.data.map((item) => {
                    item.earlytime = dayjs(item.earlytime).format('YYYY-MM-DD');
                    return item;
                });

                setState(data);
                autoCheckByDestination(data.data);
                return data;
            } else {
                return [];
            }
        },
    });

    const onMenuClick = (e) => {
        let tableData = [];
        let options = {};
        if (e.key === '1') {
            dataSource.data.map((item) => {
                let objRow = {
                    id: item.id,
                    username: item.username,
                    origin_location: item.origin_location,
                    destination_location: item.destination_location,
                    box_type: item.box_type,
                    booking_number: item.booking_number,
                    free_day: item.free_day,
                    price: item.price,
                    quantity: item.quantity,
                    weight: item.weight,
                    status_code: item.status_code,
                    earlytime: item.earlytime,
                    book_time: item.book_time,
                    endtime: item.endtime,
                    updatetime: item.updatetime,
                    is_book: item.is_book,
                };
                return tableData.push(objRow);
            });
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].is_book === 0) {
                    tableData[i].is_book = '未提交订单';
                } else if (tableData[i].is_book === 1) {
                    tableData[i].is_book = '已提交';
                } else if (tableData[i].is_book === 2) {
                    tableData[i].is_book = '超时';
                } else if (tableData[i].is_book === 3) {
                    tableData[i].is_book = '正在锁定';
                } else if (tableData[i].is_book === 4) {
                    tableData[i].is_book = '退关';
                }
            }
            options.fileName = '订单列表';
            options.datas = [
                {
                    sheetData: tableData,
                    sheetName: 'sheet',
                    sheetFilter: tableFilter,
                    sheetHeader: tableTitle,
                },
            ];
            const toExcel = new ExportJsonExcel(options);
            toExcel.saveExcel();
        } else if (e.key === '2') {
            let tableData = [];
            let options = {};
            dataSourceAll.map((item) => {
                let objRow = {
                    id: item.id,
                    username: item.username,
                    origin_location: item.origin_location,
                    destination_location: item.destination_location,
                    box_type: item.box_type,
                    booking_number: item.booking_number,
                    free_day: item.free_day,
                    price: item.price,
                    quantity: item.quantity,
                    weight: item.weight,
                    status_code: item.status_code,
                    earlytime: item.earlytime,
                    book_time: item.book_time,
                    endtime: item.endtime,
                    updatetime: item.updatetime,
                    is_book: item.is_book,
                };
                return tableData.push(objRow);
            });
            // console.log(tableData, 'tableData');
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].is_book === 0) {
                    tableData[i].is_book = '未提交订单';
                } else if (tableData[i].is_book === 1) {
                    tableData[i].is_book = '已提交';
                } else if (tableData[i].is_book === 2) {
                    tableData[i].is_book = '超时';
                } else if (tableData[i].is_book === 3) {
                    tableData[i].is_book = '正在锁定';
                } else if (tableData[i].is_book === 4) {
                    tableData[i].is_book = '退关';
                }
            }
            options.fileName = 'Hpl订单列表';
            options.datas = [
                {
                    sheetData: tableData,
                    sheetName: 'sheet',
                    sheetFilter: tableFilter,
                    sheetHeader: tableTitle,
                },
            ];
            const toExcel = new ExportJsonExcel(options);
            toExcel.saveExcel();
        }
    };

    return (
        <div className="ax-page-list">
            <PageHeader title="Hpl订单列表" sticky></PageHeader>
            <Card className="ax-search-card">
                <Form form={form} autoComplete="off">
                    <Row gutter={SEARCH_ITEM_GUTTER}>
                        <Col {...SEARCH_ITEM_COL}>
                            <Form.Item label="起始" name="origin_location">
                                <Select
                                    options={createJsonOptions(startPortOptions)}
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col {...SEARCH_ITEM_COL}>
                            <Form.Item label="目的" name="destination_location">
                                <Select
                                    options={createJsonOptions(endPortOptions)}
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>

                        <Col {...SEARCH_ITEM_COL}>
                            <Form.Item label="订单状态" name="is_book">
                                <Select options={orderStatusOptions} allowClear></Select>
                            </Form.Item>
                        </Col>
                        <Col {...SEARCH_ITEM_COL}>
                            <Form.Item label="开始时间" name="start_time">
                                <DatePicker showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }} style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col {...SEARCH_ITEM_COL}>
                            <Form.Item label="结束时间" name="end_time">
                                <DatePicker showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }} style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col {...SEARCH_ITEM_COL}>
                            <Form.Item label="开航时间" name="earlytime">
                                <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col {...SEARCH_ITEM_COL} style={{ display: 'flex' }}>
                            {/* <Form.Item style={{ width: '50%' }} label="订单分组" name="list_type">
                                <Input></Input>
                            </Form.Item> */}
                            <Form.Item style={{ width: '100%' }} label="订单分类" name="quotation_number">
                                <Select options={quotationNumberOptions} allowClear></Select>
                            </Form.Item>
                        </Col>
                        <Col {...SEARCH_ITEM_COL} style={{ display: 'flex' }}>
                            <span style={{ marginRight: '5%', marginLeft: '5%' }}>{renderSearchButton()}</span>
                            <Dropdown menu={{ items: ExcelItems, onClick: onMenuClick }}>
                                <Button>
                                    <Space>Excel导出</Space>
                                </Button>
                            </Dropdown>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Card className="ax-table-card">{renderTable()}</Card>
        </div>
    );
}
